module.exports = __webpack_public_path__ + "img/logo-responsibly-sourced.c2e8893c.png";